import React from 'react';
import { format, parseISO } from 'date-fns';
import { BookingConfirmationProps } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faClock, faGlobe, faCheck } from '@fortawesome/free-solid-svg-icons';
import './BookingConfirmation.css';

const BookingConfirmation: React.FC<BookingConfirmationProps> = ({ bookingInfo, onClose }) => {
    return (
        <div className="booking-confirmation">
            <div className="confirmation-icon">
                <FontAwesomeIcon icon={faCheck} />
            </div>
            
            <h2 className="confirmation-title">Booking Confirmed!</h2>
            
            <p className="confirmation-message">
                Your meeting has been scheduled successfully. You'll receive a confirmation email shortly.
            </p>
            
            <div className="confirmation-details">
                <div className="confirmation-event-name">
                    <FontAwesomeIcon icon={faCalendarAlt} className="icon-left" />
                    {bookingInfo.slot.eventTypeId ? `Meeting ID: ${bookingInfo.slot.eventTypeId}` : 'Scheduled Meeting'}
                </div>
                
                <div className="confirmation-time">
                    <FontAwesomeIcon icon={faClock} className="icon-left" />
                    {format(parseISO(bookingInfo.slot.start), 'EEEE, MMMM d, yyyy')} at {format(parseISO(bookingInfo.slot.start), 'h:mm a')}
                </div>
                
                <div className="confirmation-duration">
                    <FontAwesomeIcon icon={faClock} className="icon-left" />
                    {format(parseISO(bookingInfo.slot.start), 'h:mm a')} - {format(parseISO(bookingInfo.slot.end), 'h:mm a')}
                </div>
                
                <div className="confirmation-timezone">
                    <FontAwesomeIcon icon={faGlobe} className="icon-left" />
                    All times shown in {bookingInfo.timeZone}
                </div>
            </div>
            
            <button
                onClick={onClose}
                className="confirmation-button"
            >
                Close
            </button>
        </div>
    );
};

export default BookingConfirmation; 